// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"C2-z","dimensionLabel":"D2-z","styleChooserControlWrapper":"E2-z","styleChooserControl":"F2-z","disabled":"G2-z","giftCard":"H2-z","styleChooserText":"I2-z"};